module.exports = __webpack_public_path__ + "static/media/capa_trofeus.56701a4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/capa_trofeus.jpg
// module id = 364
// module chunks = 0